var React = require('react');

function Add12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 0V5H12V7H7V12H5V7H0V5H5V0H7Z","fill":"currentColor"}));
}

Add12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Add12;

Add12.default = Add12;
